import { ThemeConfig, theme } from 'antd';

import { Theme } from '@emotion/react';

import darkTheme from '@/assets/themes/dark';
import defaultTheme from '@/assets/themes/default';
import lightTheme from '@/assets/themes/light';
import { remapThemeColorPrimary } from '@/helpers/theme';
import { ThemeMode } from '@/interfaces/theme';

const themeMap = {
  dark: darkTheme,
  light: lightTheme
};

const themeAlgorithm = {
  dark: theme.darkAlgorithm,
  light: theme.defaultAlgorithm
};

type SubdomainColors = {
  dark: string;
  light: string;
};

const useThemeSelector = (mode: ThemeMode, subdomainTheme: SubdomainColors) => {
  const { token, components, variables } = {
    dark: remapThemeColorPrimary(darkTheme, subdomainTheme?.dark),
    light: remapThemeColorPrimary(lightTheme, subdomainTheme?.light)
  }[mode];

  const antdTheme = {
    algorithm: themeAlgorithm[mode],
    token,
    components
  } as ThemeConfig;

  const emotionTheme = {
    ...defaultTheme,
    ...token,
    ...components,
    isDarkMode: mode === 'dark',
    variables: { ...defaultTheme.variables, ...variables }
  } as Partial<Theme>;

  return { emotionTheme, antdTheme };
};

export default useThemeSelector;
